<template>
    <div class="module__list_table">
        <component-table
            :labels="[
                {
                    key: 'name',
                    title: 'Name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'description',
                    title: 'Description',
                    type: 'string'
                },
                {
                    key: 'duration',
                    title: 'Duration',
                    type: 'string'
                },
                {
                    key: 'labels',
                    title: 'Labels',
                    type: 'string'
                },
                {
                    key: 'keywords',
                    title: 'Keywords',
                    type: 'string'
                },
                {
                    key: 'status',
                    title: 'Status',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: 'string',
                    sortable: false
                }
            ]"
            :items="items"
            :component-table-item="ModuleListTableItem"
            :sort-queryable="sortQueryable"
            @emit-archive-module="openNotifyArchiveModule"
            @emit-reactivate-module="openNotifyReactivateModule"
            @emit-sort="handleSort"
        />
        <pop-notify
            ref="notifyarchivemodule"
            :class="'pop__notify--archive'"
            :title-text="`Archive module?`"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Archive module'"
            :submit-button-animate-loading="true"
            :submit-button-danger="true"
            :prevent-close="true"
            :content-text="''"
            @emit-submit="performArchiveModule"
        >
            <template v-if="notifyModuleIncludedInCourses > 0">
                This module is used in {{ notifyModuleIncludedInCourses }} {{ notifyModuleIncludedInCourses <= 1 ? 'course.' : 'courses.' }} <br><br>
                <component-button
                    :name="'archive-module-notify-view-usage'"
                    :text="true"
                    :to="{ name: 'ebs-course-list', query: { modules: `${notifyModuleId};${notifyModuleName}` }}"
                >View usage</component-button>
                <br><br>
            </template>
            Archived modules: <br>
            - Will no longer be available to add to courses <br>
            - Are not removed from existing courses or reports <br>
            - Can be re-activated at any time <br><br>
            Do you wish to archive this module?
        </pop-notify>
        <pop-notify
            ref="notifyreactivatemodule"
            :class="'pop__notify--reactivate'"
            :title-text="`Re-activate module?`"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Re-activate module'"
            :submit-button-animate-loading="true"
            :submit-button-icon="true"
            :submit-button-icon-name="'refresh-cw'"
            :submit-button-icon-align="'right'"
            :prevent-close="true"
            :content-text="''"
            @emit-submit="performReactivateModule"
        >
            Re-activating this module will make it available to add to courses.<br><br>
            Do you wish to re-activate this module?
        </pop-notify>
    </div>
</template>

<script>
import ModuleListTableItem from '@/components/ebs/modules/list/ModuleListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'
import PopNotify from "@/components/default/shared/PopNotify";
import ComponentButton from "@/components/default/shared/ComponentButton";

export default {
  components: {
    ComponentButton,
    PopNotify,
    ComponentTable
  },
  name: 'module-list-table',
  data () {
    return {
      ModuleListTableItem,
      notifyModuleId: '',
      notifyModuleName: '',
      notifyModuleIncludedInCourses: 0
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    closeNotifyArchiveModule () {
      this.$refs.notifyarchivemodule.closeNotify()
    },
    openNotifyArchiveModule (data) {
      this.notifyModuleId = data.moduleId || ''
      this.notifyModuleName = data.moduleName || ''
      this.notifyModuleIncludedInCourses = data.moduleIncludedInCourses || 0
    
      this.$refs.notifyarchivemodule.openNotify()
    },
    closeNotifyReactivateModule () {
      this.$refs.notifyarchivemodule.closeNotify()
    },
    openNotifyReactivateModule (data) {
      this.notifyModuleId = data.moduleId || ''
    
      this.$refs.notifyreactivatemodule.openNotify()
    },
    performArchiveModule () {
      this.$store.dispatch('ebsModuleDelete', this.notifyModuleId).finally(() => {
        this.closeNotifyArchiveModule()
      }).then(() => {
        this.$eventBus.$emit('get-modules-list')
      })
    },
    performReactivateModule () {
      this.$store.dispatch('ebsModuleUndelete', this.notifyModuleId).finally(() => {
        this.closeNotifyReactivateModule()
      }).then(() => {
        this.$eventBus.$emit('get-modules-list')
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/modulelisttable";
</style>
